import { combineReducers } from "redux";

// Reducers
import academyReducer from "./academyReducer";
import anniversaryReducer from "./anniversaryReducer";
import appConfigReducer from "./appConfigReducer";
import authReducer from "./authReducer";
import birthdayReducer from "./birthdayReducer";
import checklistReducer from "./checklistReducer";
import contactReducer from "./contactReducer";
import equipmentBookingReducer from "./equipmentBookingReducer";
import eventReducer from "./eventReducer";
import languageReducer from "./languageReducer";
import newsReducer from "./newsReducer";
import pagesReducer from "./pagesReducer";
import registrationReducer from "./registrationReducer";
import searchPageReducer from "./searchPageReducer";
import sideMenuReducer from "./sideMenuReducer";
import socialReducer from "./socialReducer";
import targetGroupModalReducer from "./targetGroupModalReducer";
import themeQuizReducer from "./themeQuizReducer";
import uiReducer from "./uiReducer";

export default combineReducers({
  academy: academyReducer,
  anniversary: anniversaryReducer,
  appConfig: appConfigReducer,
  auth: authReducer,
  birthday: birthdayReducer,
  checklist: checklistReducer,
  contact: contactReducer,
  equipmentBooking: equipmentBookingReducer,
  event: eventReducer,
  language: languageReducer,
  news: newsReducer,
  pages: pagesReducer,
  registration: registrationReducer,
  searchPage: searchPageReducer,
  sideMenu: sideMenuReducer,
  social: socialReducer,
  targetGroupModal: targetGroupModalReducer,
  themeQuiz: themeQuizReducer,
  ui: uiReducer,
});
